import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('comment');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null,
            isReported = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC',
            isReported
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get('/admin/comments', {
            params
        });
    },

    reports(vuexContext, id) {
        return axios.$get(`admin/comments/${id}/reports`);
    }
};
